import { render } from "./CadastroVeiculoTrator.vue?vue&type=template&id=51eb7f3c"
import script from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
export * from "./CadastroVeiculoTrator.vue?vue&type=script&lang=ts"
script.render = render

export default script